import { GetRemittanceDetailsType } from '../../../../types/Invoicing/RemittanceDetails/remittanceDetailstype'
import {
  getAuthenticatedRequestConfig,
  useAxios,
} from '../../../../utils/apiUtils'
import { AddBankApiConfig, AllowedHttpMethods } from '../../apiList'

const remittance = async (): Promise<GetRemittanceDetailsType> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: AddBankApiConfig.remittance,
    method: AllowedHttpMethods.get,
  })

  const response = await useAxios(requestConfig)
  return response.data
}

const addBankType = async (name: string): Promise<string> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: AddBankApiConfig.addBank,
    method: AllowedHttpMethods.post,
    data: {
      name,
    },
  })

  const response = await useAxios(requestConfig)
  return response.data
}

const deleteBank = async (bankId: number): Promise<number | undefined> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: AddBankApiConfig.deleteBank,
    method: AllowedHttpMethods.delete,
    params: { bankId },
  })

  const response = await useAxios(requestConfig)
  return response.data
}
const remittanceApi = {
  remittance,
  addBankType,
  deleteBank,
}

export default remittanceApi
